<template>
  <vs-popup class="formula_note_update_popup"
            id="popup"
            title="FORMULATIONS PRODUCT CATALOGUE UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreate)" autocomplete="off">

          <vx-card-custom class="mx-10" subtitle="SDS DOCUMENTS" :cardBorder="true" no-shadow  :remove-card-action="false"  :collapse-action="false">
            <div class="vx row">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <multi-file-uploader
                  v-on:onSetFileName="onSetSdsFile($event)"
                  :file="''"
                  file_path="formulation/sds-documents"
                  :condition="true"/>
<!--              <vs-button class="mt-4 mb-4 ml-4" @click="onClickGenerateSdsDoc()" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">-->
<!--                Generate-->
<!--              </vs-button>-->
              </div>
              <span style="display: none">{{ form.sds_documents }}</span>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <span v-for="(file, index_sds) in form.sds_documents" :key="index_sds">
                          <a :href="file.file" target="_blank">{{__nameSplitter(file.file)}}</a>
                        <feather-icon @click="onClickRemoveSdsFile(index_sds)" icon="XIcon" class="text-danger w-4 mt-2 ml-2 cursor-pointer"/>
                        <br>
                        </span>
              </div>
            </div>
<!--            <vs-row vs-w="12" class="mt-0">-->
<!--              <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                      <span v-for="(doc, index_file) in form.sds_documents" :key="index_file">-->
<!--                          <a :href="doc.file" target="_blank">{{__nameSplitter(doc.file)}}</a>-->
<!--                        <feather-icon @click="onClickRemoveSdsFile(index_file)" icon="XIcon" class="text-danger w-4 mt-2 ml-2 cursor-pointer"/>-->
<!--                        <br>-->
<!--                        </span>-->
<!--              </div>-->
<!--            </vs-row>-->
          </vx-card-custom>

          <vx-card titleColor="#736F6E" title="" class="mb-8" no-shadow>
            <vs-row vs-w="12" class="mt-0">
              <vs-col v-for="(social, index_contact) in form.documentation" :key="index_contact"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="6" vs-sm="6" vs-xs="12"
                      class="px-4 pb-4">
                <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="onDeleteDoc(index_contact)" :remove-card-action="true"  :collapse-action="false">
                  <div class="vx-row mb-2">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider  :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                        <small class="label">Type</small>
                        <v-select
                          :clearable="false" name="type"
                          placeholder=""
                          v-model="social.name"
                          :options="['Tech Specification', 'Other']"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-4 md:mb-0">
                      <multi-file-uploader
                        v-on:onSetFileName="onSetFile($event, index_contact)"
                        :file="''"
                        file_path="formulation/documents"
                        :condition="true"/>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <span v-for="(file, index_file) in social.files" :key="index_file">
                          <a :href="file" target="_blank">{{__nameSplitter(file)}}</a>
                        <feather-icon @click="onClickRemoveFile(index_contact, index_file)" icon="XIcon" class="text-danger w-4 mt-2 ml-2 cursor-pointer"/>
                        <br>
                        </span>
                    </div>
                  </div>

                </vx-card-custom>
              </vs-col>
            </vs-row>
            <vs-button class="mt-4 mb-4 ml-4" @click="onAddDoc()" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new document</vs-button>
          </vx-card>


<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Documentation type</small>-->
<!--                <v-select :clearable="false" placeholder="" v-model="form.document_type"  :options="['SDS Documentation','Other']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->

<!--            <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="form.document_type === 'Other'">-->
<!--              <ValidationProvider vid="other_name" name="other_name" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Document Type</small>-->
<!--                <vs-input v-model="form.other_name"   name="other_name" class="w-full required" label=""/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->



<!--          <div class="vx-row mb-3" v-for="f in files_array" :key="Math.random()">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider vid="s_d_s_documentation" name="s_d_s_documentation" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">SDS Documentation</small>-->
<!--                                <file-uploader v-on:onSetFileName="value => form.s_d_s_documentation = value"-->
<!--                                               v-on:onClickFileRemove="form.s_d_s_documentation = null"-->
<!--                                               :file="form.s_d_s_documentation" :condition="true"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <FormulateInput-->
<!--                type="file"-->
<!--                name="file"-->
<!--                label="Select your documents to upload"-->
<!--                help="Select one or more PDFs to upload"-->
<!--                validation="mime:application/pdf"-->
<!--                multiple-->
<!--                v-model="files_array"-->
<!--              />-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <span v-for="(file, index) in initial_files" :key="index">-->
<!--                  <a :href="file" target="_blank">{{__nameSplitter(file)}}</a>-->
<!--                <feather-icon @click="onClickRemoveFile(index)" icon="XIcon" class="text-danger w-4 mt-2 ml-2 cursor-pointer"/>-->
<!--                <br>-->
<!--                </span>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save changes</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const FormulationsRepository = RepositoryFactory.get('formulations')
  const UlRepository = RepositoryFactory.get('ul')

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        sds_documents: [],
        documentation: [
          {
            name:   '',
            files: []
          }
        ],

      },
      files_array: [],
      initial_files: []
    }
  }

export default {
  name: 'UpdateProductCataloguePopUp',
  data () {
    return initialState()
  },
  props: {
    type: {type: String, default: ''},
    product_catalogue_info: {
      type: Object,
      default: { sds_documents: [], documentation: [] },
    }
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true
        if(this.product_catalogue_info) {
          this.form.documentation =  this.product_catalogue_info.documentation ? this.product_catalogue_info.documentation : []
          this.form.sds_documents =  this.product_catalogue_info.sds_documents ? this.product_catalogue_info.sds_documents : []
        }
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickCreate () {
      const vue = this;
      try {
        this.$vs.loading();
        // const payload = this.form
        // let files = []
        // if(this.files_array.results) {
        //   files = this.files_array.results.map((n) => {
        //     return n.data.file
        //   })
        // }
        // const new_files = [...files, ...this.initial_files]
        // if(payload.document_type === 'SDS Documentation') {
        //   const object = {name: 'SDS Documentation', files: new_files}
        //   payload.documentation.push(object)
        // } else {
        //   const object = {name: this.form.other_name, files: new_files}
        //   payload.documentation.push(object)
        // }
        await FormulationsRepository.updateFormulaProductCatalogue(this.id, this.form)
        this.showSuccessMessage('Formulation product catalogue updated');
        await vue.$parent.refreshData()
        this.open = false
      } catch (e) {
        this.open = false
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    onClickRemoveFile (index_doc, index_file) {
      this.form.documentation[index_doc].files.splice(index_file, 1)
    },
    onAddDoc() {
      this.form.documentation.push(  { name: '', files: [] } )
    },
    onDeleteDoc(index) {
      this.form.documentation.splice(index, 1)
    },
    onSetFile(data, index) {
      this.form.documentation[index].files.push(data)
    },
    async onSetSdsFile(data) {
      this.form.sds_documents.push({ file: data, timestamp: Date.now()+"" })
      await this.$forceUpdate()
    },
    async onClickGenerateSdsDoc() {
      this.$vs.loading();
      try {
        const { data } =  await UlRepository.getFormulationSdsDocument('')
        this.form.sds_documents.push({ file: data.data.file, timestamp: Date.now()+"" })
        await this.$forceUpdate()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async onClickRemoveSdsFile(index) {
      this.form.sds_documents.splice(index, 1)
      await this.$forceUpdate()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .formula_note_update_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }
</style>
